/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { army } from '../models/army';
import type { army_all } from '../models/army_all';
import type { army_category } from '../models/army_category';
import type { army_category_all } from '../models/army_category_all';
import type { army_category_full } from '../models/army_category_full';
import type { army_category_last_update } from '../models/army_category_last_update';
import type { army_full } from '../models/army_full';
import type { army_last_update } from '../models/army_last_update';
import type { army_organisation_all } from '../models/army_organisation_all';
import type { army_organisation_full } from '../models/army_organisation_full';
import type { army_version_all } from '../models/army_version_all';
import type { constrainable_all } from '../models/constrainable_all';
import type { constraint_all } from '../models/constraint_all';
import type { constraint_full } from '../models/constraint_full';
import type { deployment_full } from '../models/deployment_full';
import type { game_pack_full } from '../models/game_pack_full';
import type { magic_item_all } from '../models/magic_item_all';
import type { magic_item_full } from '../models/magic_item_full';
import type { magic_path } from '../models/magic_path';
import type { magic_path_all } from '../models/magic_path_all';
import type { magic_path_full } from '../models/magic_path_full';
import type { magic_standard_all } from '../models/magic_standard_all';
import type { magic_standard_full } from '../models/magic_standard_full';
import type { map_full } from '../models/map_full';
import type { model_rule_all } from '../models/model_rule_all';
import type { model_rule_full } from '../models/model_rule_full';
import type { objective_full } from '../models/objective_full';
import type { organisation_all } from '../models/organisation_all';
import type { organisation_full } from '../models/organisation_full';
import type { search_model_rule_dto } from '../models/search_model_rule_dto';
import type { search_unit_dto } from '../models/search_unit_dto';
import type { spell_all } from '../models/spell_all';
import type { spell_full } from '../models/spell_full';
import type { troop_all } from '../models/troop_all';
import type { troop_full } from '../models/troop_full';
import type { unit_all } from '../models/unit_all';
import type { unit_category } from '../models/unit_category';
import type { unit_category_all } from '../models/unit_category_all';
import type { unit_full } from '../models/unit_full';
import type { unit_option_all } from '../models/unit_option_all';
import type { unit_option_full } from '../models/unit_option_full';
import type { unit_option_group_all } from '../models/unit_option_group_all';
import type { unit_option_group_full } from '../models/unit_option_group_full';
import type { unit_profil } from '../models/unit_profil';
import type { user_favorite_unit_dto } from '../models/user_favorite_unit_dto';
import type { user_favorite_unit_full } from '../models/user_favorite_unit_full';
import type { version_all } from '../models/version_all';
import type { version_full } from '../models/version_full';
import type { version_magic_item_all } from '../models/version_magic_item_all';
import type { version_magic_item_full } from '../models/version_magic_item_full';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NinthAgeService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get all armies with full informations
   * @returns army_full successful
   * @throws ApiError
   */
  public getArmies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all armies with full informations for one version
   * @returns army_all successful
   * @throws ApiError
   */
  public getAllArmies({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<army_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/armies/all.json',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all armies with full informations for one version
   * @returns army_full successful
   * @throws ApiError
   */
  public getFullArmies({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<army_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/armies/full.json',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get army with full informations
   * @returns army successful
   * @throws ApiError
   */
  public getArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<army> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}.json',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all armies with updated_at
   * @returns army_last_update successful
   * @throws ApiError
   */
  public getUpdatedAtArmies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_last_update>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/last_update.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all army categories with minimal informations
   * @returns army_category_all successful
   * @throws ApiError
   */
  public getAllArmyCategories({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_category_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/all',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all army categories with full informations
   * @returns army_category_full successful
   * @throws ApiError
   */
  public getFullArmyCategories({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_category_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/full',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get army category with full informations
   * @returns army_category successful
   * @throws ApiError
   */
  public getArmyCategory({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<army_category> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/{army_id}.json',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all armies with updated_at
   * @returns army_category_last_update successful
   * @throws ApiError
   */
  public getUpdatedAtArmyCategories({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_category_last_update>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/last_update.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all army organisations with minimal informations
   * @returns army_organisation_all successful
   * @throws ApiError
   */
  public getAllArmyOrganisations({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<army_organisation_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/army_organisations/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all army organisations with full informations
   * @returns army_organisation_full successful
   * @throws ApiError
   */
  public getFullArmyOrganisations({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<army_organisation_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/army_organisations/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all constrainables with minimal informations
   * @returns constrainable_all successful
   * @throws ApiError
   */
  public getAllConstrainables({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<constrainable_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/constrainables/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all army limits with minimal informations
   * @returns constraint_all successful
   * @throws ApiError
   */
  public getAllArmyLimits({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<constraint_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/constraints/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all army limits path with full informations
   * @returns constraint_full successful
   * @throws ApiError
   */
  public getFullArmyLimits({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<constraint_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/constraints/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all army limits path with minimal informations
   * @returns constraint_all successful
   * @throws ApiError
   */
  public getArmyAllArmyLimits({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<constraint_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/constraints/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all army limits path with full informations
   * @returns constraint_full successful
   * @throws ApiError
   */
  public getArmyFullArmyLimits({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<constraint_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/constraints/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all deployments
   * @returns deployment_full successful
   * @throws ApiError
   */
  public getAllDeployments({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<deployment_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/deployments.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all game packs
   * @returns game_pack_full successful
   * @throws ApiError
   */
  public getAllGamePacks({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<game_pack_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/game_packs',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all magic items path with minimal informations
   * @returns magic_item_all successful
   * @throws ApiError
   */
  public getAllMagicItems({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_item_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_items/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all magic items path with full informations
   * @returns magic_item_full successful
   * @throws ApiError
   */
  public getFullMagicItems({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_item_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_items/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all magic items path with minimal informations
   * @returns magic_item_all successful
   * @throws ApiError
   */
  public geArmyAllMagicItems({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_item_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/magic_items/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all magic items path with full informations
   * @returns magic_item_full successful
   * @throws ApiError
   */
  public getArmyFullMagicItems({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_item_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/magic_items/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get magic paths by version
   * @returns magic_path successful
   * @throws ApiError
   */
  public getMagicPathsByVersion({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_path>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/versions/{version_id}/magic_paths',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all magic paths with minimal informations
   * @returns magic_path_all successful
   * @throws ApiError
   */
  public getAllMagicPaths({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_path_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_paths/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all magic paths with full informations
   * @returns magic_path_full successful
   * @throws ApiError
   */
  public getFullMagicPaths({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_path_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_paths/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all magic paths with minimal informations by army
   * @returns magic_path_all successful
   * @throws ApiError
   */
  public getAllMagicPathsByArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_path_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/magic_paths/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all magic paths with full informations by army
   * @returns magic_path_full successful
   * @throws ApiError
   */
  public getFullMagicPathsByArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_path_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/magic_paths/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get magic path
   * @returns magic_path successful
   * @throws ApiError
   */
  public getMagicPath({
    locale,
    pathId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Magic Path identifier
     */
    pathId: number;
  }): CancelablePromise<magic_path> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/magic_paths/{path_id}',
      path: {
        locale: locale,
        path_id: pathId,
      },
    });
  }
  /**
   * Get all MagicStandards with minimal informations
   * @returns magic_standard_all successful
   * @throws ApiError
   */
  public getAllMagicStandards({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_standard_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_standards/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all MagicStandards path with full informations
   * @returns magic_standard_full successful
   * @throws ApiError
   */
  public getFullMagicStandards({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<magic_standard_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/magic_standards/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all MagicStandards path with minimal informations
   * @returns magic_standard_all successful
   * @throws ApiError
   */
  public getArmyAllMagicStandards({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_standard_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/magic_standards/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all MagicStandards path with full informations
   * @returns magic_standard_full successful
   * @throws ApiError
   */
  public getArmyFullMagicStandards({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<magic_standard_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/magic_standards/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all maps
   * @returns map_full successful
   * @throws ApiError
   */
  public getAllMaps({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<map_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/maps',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get a map
   * @returns map_full successful
   * @throws ApiError
   */
  public getMap({
    locale,
    mapId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Map identifier
     */
    mapId: number;
  }): CancelablePromise<map_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/maps/{map_id}',
      path: {
        locale: locale,
        map_id: mapId,
      },
    });
  }
  /**
   * Get all model rules with minimal informations
   * @returns model_rule_all successful
   * @throws ApiError
   */
  public getAllModelRules({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<model_rule_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/model_rules/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all model rules path with full informations
   * @returns model_rule_full successful
   * @throws ApiError
   */
  public getFullModelRules({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<model_rule_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/model_rules/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all model rules path with minimal informations
   * @returns model_rule_all successful
   * @throws ApiError
   */
  public getArmyAllModelRules({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<model_rule_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/model_rules/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all model rules path with full informations
   * @returns model_rule_full successful
   * @throws ApiError
   */
  public getArmyFullModelRules({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<model_rule_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/model_rules/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all model rules with minimal informations
   * @returns model_rule_all successful
   * @throws ApiError
   */
  public getAllModelRulesByversionMagicItem({
    locale,
    versionMagicItemId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version Magic Item identifier
     */
    versionMagicItemId: number;
  }): CancelablePromise<Array<model_rule_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version_magic_items/{version_magic_item_id}/model_rules/all',
      path: {
        locale: locale,
        version_magic_item_id: versionMagicItemId,
      },
    });
  }
  /**
   * Search model rules by version and armies
   * @returns model_rule_full successful
   * @throws ApiError
   */
  public searchModelRules({
    locale,
    versionId,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
    requestBody?: search_model_rule_dto;
  }): CancelablePromise<Array<model_rule_full>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/model_rules/search',
      path: {
        locale: locale,
        version_id: versionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all objectives
   * @returns objective_full successful
   * @throws ApiError
   */
  public getAllObjectives({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<objective_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/objectives.json',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all organisations path with minimal informations
   * @returns organisation_all successful
   * @throws ApiError
   */
  public getAllOrganisations({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<organisation_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/organisations/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all organisations path with full informations
   * @returns organisation_full successful
   * @throws ApiError
   */
  public getFullOrganisations({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<organisation_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/organisations/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get magic path spells by path
   * @returns spell_all successful
   * @throws ApiError
   */
  public getAllMagicPathSpellsByPath({
    locale,
    pathId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Magic Path identifier
     */
    pathId: number;
  }): CancelablePromise<Array<spell_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/magic-paths/{path_id}/spells/all',
      path: {
        locale: locale,
        path_id: pathId,
      },
    });
  }
  /**
   * Get magic path spells by path
   * @returns spell_full successful
   * @throws ApiError
   */
  public getFullMagicPathSpellsByPath({
    locale,
    pathId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Magic Path identifier
     */
    pathId: number;
  }): CancelablePromise<Array<spell_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/magic-paths/{path_id}/spells/full',
      path: {
        locale: locale,
        path_id: pathId,
      },
    });
  }
  /**
   * Get all troops with minimal informations
   * @returns troop_all successful
   * @throws ApiError
   */
  public getAllTroops({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<troop_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/units/{unit_id}/troops/all',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all troops with full informations
   * @returns troop_full successful
   * @throws ApiError
   */
  public getFullTroops({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<troop_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/units/{unit_id}/troops/full',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all unit categories with minimal informations
   * @returns unit_category_all successful
   * @throws ApiError
   */
  public getAllUnitCategories({
    locale,
    armyCategoryId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army category identifier
     */
    armyCategoryId: number;
  }): CancelablePromise<Array<unit_category_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/{army_category_id}/unit_categories/all',
      path: {
        locale: locale,
        army_category_id: armyCategoryId,
      },
    });
  }
  /**
   * Get all unit categories with minimal informations
   * @returns unit_category_all successful
   * @throws ApiError
   */
  public getAllUnitCategoriesByArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_category_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/unit_categories/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all unit categories with full informations
   * @returns unit_category successful
   * @throws ApiError
   */
  public getFullUnitCategories({
    locale,
    armyCategoryId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army category identifier
     */
    armyCategoryId: number;
  }): CancelablePromise<Array<unit_category>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/{army_category_id}/unit_categories/full',
      path: {
        locale: locale,
        army_category_id: armyCategoryId,
      },
    });
  }
  /**
   * Get all unit categories with full informations
   * @returns unit_category successful
   * @throws ApiError
   */
  public getFullUnitCategoriesByArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_category>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/unit_categories/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all unit option groups path with minimal informations
   * @returns unit_option_group_all successful
   * @throws ApiError
   */
  public getAllUnitOptionGroups({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<unit_option_group_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/units/{unit_id}/unit_option_groups/all',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all unit option groups with full informations
   * @returns unit_option_group_full successful
   * @throws ApiError
   */
  public getFullUnitOptionGroups({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<unit_option_group_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/units/{unit_id}/unit_option_groups/full',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all unit options path with minimal informations
   * @returns unit_option_all successful
   * @throws ApiError
   */
  public getAllUnitOptions({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<unit_option_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/unit-{unit_id}/unit_options/all',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all units path with full informations
   * @returns unit_option_full successful
   * @throws ApiError
   */
  public getFullUnitOptions({
    locale,
    unitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Unit identifier
     */
    unitId: number;
  }): CancelablePromise<Array<unit_option_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/unit-{unit_id}/unit_options/full',
      path: {
        locale: locale,
        unit_id: unitId,
      },
    });
  }
  /**
   * Get all units path with minimal informations
   * @returns unit_all successful
   * @throws ApiError
   */
  public getAllUnits({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/units/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all units path with minimal informations
   * @returns unit_all successful
   * @throws ApiError
   */
  public getAllUnitsByversionMagicItem({
    locale,
    versionMagicItemId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version Magic Item identifier
     */
    versionMagicItemId: number;
  }): CancelablePromise<Array<unit_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version_magic_items/{version_magic_item_id}/units/all',
      path: {
        locale: locale,
        version_magic_item_id: versionMagicItemId,
      },
    });
  }
  /**
   * Get all mounts path with minimal informations
   * @returns unit_all successful
   * @throws ApiError
   */
  public getFullUnits({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/mounts/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all units path with full informations
   * @returns unit_full successful
   * @throws ApiError
   */
  public getFullUnitByOrganisations({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/units/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all units profil informations
   * @returns unit_profil successful
   * @throws ApiError
   */
  public getProfilUnitByArmy({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<unit_profil>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/units/profil',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * All units filtered by rules path with full informations
   * @returns unit_full successful
   * @throws ApiError
   */
  public searchUnits({
    locale,
    versionId,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
    requestBody?: search_unit_dto;
  }): CancelablePromise<Array<unit_full>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/units/search',
      path: {
        locale: locale,
        version_id: versionId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all your favorite units
   * @returns user_favorite_unit_full successful
   * @throws ApiError
   */
  public getAllUserFavoriteUnits({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<user_favorite_unit_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army-{army_id}/user_favorite_units',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Create a favorite unit
   * @returns user_favorite_unit_full successful
   * @throws ApiError
   */
  public createUserFavoriteUnit({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: user_favorite_unit_dto;
  }): CancelablePromise<user_favorite_unit_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/ninth_age/user_favorite_units',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete favorite unit
   * @returns void
   * @throws ApiError
   */
  public deleteUserFavoriteUnit({
    locale,
    favoriteUnitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Favorite unit identifier
     */
    favoriteUnitId: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/ninth_age/user_favorite_units/{favorite_unit_id}',
      path: {
        locale: locale,
        favorite_unit_id: favoriteUnitId,
      },
    });
  }
  /**
   * Get all version magic items path with minimal informations
   * @returns version_magic_item_all successful
   * @throws ApiError
   */
  public getAllVersionMagicItems({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<version_magic_item_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/version_magic_items/all',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all version magic items path with full informations
   * @returns version_magic_item_full successful
   * @throws ApiError
   */
  public getFullVersionMagicItems({
    locale,
    versionId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Version identifier
     */
    versionId: number;
  }): CancelablePromise<Array<version_magic_item_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/version-{version_id}/version_magic_items/full',
      path: {
        locale: locale,
        version_id: versionId,
      },
    });
  }
  /**
   * Get all version magic items path with minimal informations
   * @returns version_magic_item_all successful
   * @throws ApiError
   */
  public getByArmyAllVersionMagicItems({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<version_magic_item_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/version_magic_items/all',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all version magic items path with full informations
   * @returns version_magic_item_full successful
   * @throws ApiError
   */
  public getByArmyFullVersionMagicItems({
    locale,
    armyId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army identifier
     */
    armyId: number;
  }): CancelablePromise<Array<version_magic_item_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/armies/{army_id}/version_magic_items/full',
      path: {
        locale: locale,
        army_id: armyId,
      },
    });
  }
  /**
   * Get all army versions for an army
   * @returns army_version_all successful
   * @throws ApiError
   */
  public getAllArmyVersions({
    locale,
    armyCategoryId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army Category identifier
     */
    armyCategoryId: number;
  }): CancelablePromise<Array<army_version_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/{army_category_id}/versioning/army_versions/all',
      path: {
        locale: locale,
        army_category_id: armyCategoryId,
      },
    });
  }
  /**
   * Get full informations for army versions for an army
   * @returns army_version_all successful
   * @throws ApiError
   */
  public getFullArmyViersions({
    locale,
    armyCategoryId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army Category identifier
     */
    armyCategoryId: number;
  }): CancelablePromise<Array<army_version_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/army_categories/{army_category_id}/versioning/army_versions/full',
      path: {
        locale: locale,
        army_category_id: armyCategoryId,
      },
    });
  }
  /**
   * Get all versions with minimal informations
   * @returns version_all successful
   * @throws ApiError
   */
  public getAllVersions({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<version_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/versions/all',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all versions with full informations
   * @returns version_full successful
   * @throws ApiError
   */
  public getFullVersions({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<version_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/versions/full',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get all versions with updated_at
   * @returns version_full successful
   * @throws ApiError
   */
  public getUpdatedAtVersions({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<version_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/ninth_age/versions/last_update',
      path: {
        locale: locale,
      },
    });
  }
}
